import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { useData } from '../../contexts/DataContext';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export const RequestsChart = () => {
  const { data } = useData();

  const chartData = data.rateRequests.map(item => ({
    hour: `${item.hour}:00`,
    'Live': item.live,
    'Zone': item.zone,
    'Estimate': item.estimate,
    'Failed': item.failed,
  }));

  return (
    <Card>
      <CardHeader>
        <CardTitle>Rate Requests (24h)</CardTitle>
        <CardDescription>Request distribution by response mode</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
            <XAxis 
              dataKey="hour" 
              className="text-xs text-muted-foreground"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
            />
            <YAxis 
              className="text-xs text-muted-foreground"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
                color: 'hsl(var(--foreground))',
              }}
            />
            <Legend />
            <Bar dataKey="Live" stackId="a" fill="hsl(var(--chart-1))" radius={[0, 0, 4, 4]} />
            <Bar dataKey="Zone" stackId="a" fill="hsl(var(--chart-4))" radius={[0, 0, 4, 4]} />
            <Bar dataKey="Estimate" stackId="a" fill="hsl(var(--chart-2))" radius={[0, 0, 4, 4]} />
            <Bar dataKey="Failed" stackId="a" fill="hsl(var(--chart-5))" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
